import _ from 'lodash';
import React from 'react';

function useWindowScrollY() {
    const windowScrollHeightRef = React.useRef<any>();
    React.useLayoutEffect(() => {
        let onScroll = () => {
            windowScrollHeightRef.current = window.scrollY;
        };
        onScroll = _.debounce(onScroll, 300);
        window.addEventListener('scroll', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    const run = React.useCallback((aNumber?: number) => {
        window?.scrollTo(0, aNumber ?? windowScrollHeightRef.current);
    }, []);

    return {
        setScrollY: run,
        scrollY: windowScrollHeightRef.current
    };
}

export default useWindowScrollY;
